import {SexeEnum} from 'src/app/model/enums/sexe.enum';

export class InfoRegisterEventDTO {
    age: Date;
    sex: SexeEnum;
    idPlace: number;
    idUser: number;
}
